(function () {
  function initSlider(el) {
    if (!el || !window.Swiper) return;
    if (el.swiper) el.swiper.destroy(true, true);

    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        750: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
      },
    });
  }

  function initAll(root) {
    root.querySelectorAll('.ctr-customers__slider').forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
